import isEqual from 'fast-deep-equal';

import { isSignature } from '@blaze-shared/schema-domain';
import { isEmptyValueOrRef } from '@blaze-shared/shared-util';

/**
 * Whether the user has entered nothing: the value still matches the blank row the form
 * started from, ignoring the emptiness the two express differently.
 */
export function isFormValueBlank(
  value: Record<string, any>,
  blankValue: Record<string, any>,
): boolean {
  return isEqual(withoutEmptyFields(value), withoutEmptyFields(blankValue));
}

/**
 * Whether every row of a form list is untouched or already deleted. `__isEmptyish` marks a
 * row the list generated for the user to fill in, which they never did.
 */
export function areFormListRowsBlank(rows: Record<string, any>[]): boolean {
  return rows.every((row) => row.__isEmptyish || row._isDeleted);
}

/** Signatures are kept: an empty-looking signature value still means the user signed. */
function withoutEmptyFields(row: Record<string, any>): Record<string, any> {
  const result: Record<string, any> = {};
  for (const [key, value] of Object.entries(row ?? {})) {
    if (!isEmptyValueOrRef(value) || isSignature(value)) {
      result[key] = value;
    }
  }
  return result;
}
